import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { logOut } from 'actions'
import { chatNotificationCountSelector } from 'selectors'

import NotificationsComponent from 'components/Notifications'

import Header from './Header'

const Wrapper = styled.div`
  position: relative;
`

const Notifications = styled(NotificationsComponent)`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(calc(100% + 4px), -50%);
`

const Customer = ({ logOut, count }) => (
  <Header
    searchField
    menu={[
      {
        link: '/unlisted',
        text: 'Nye',
      },
      {
        link: '/chat',
        text: (
          <Wrapper>Chat{count > 0 && <Notifications count={count} />}</Wrapper>
        ),
      },
      {
        link: '/profile',
        text: 'Profil',
      },
    ]}
    moreMenu={[
      {
        link: '/settings',
        text: 'Innstillinger',
      },
      {
        onClick: logOut,
        text: 'Logg ut',
      },
    ]}
  />
)

const mapStateToProps = state => ({
  count: chatNotificationCountSelector(state),
})

const mapDispatchToProps = { logOut }

export default connect(mapStateToProps, mapDispatchToProps)(Customer)



// WEBPACK FOOTER //
// ./src/components/Header/Admin.js